// LaunchDarkly feature flag names
export const FEATURE_FLAG_PAZE_ON_COLO2 = "PAZE_ON_COLO2";
export const FEATURE_FLAG_HORIZONTAL_SCROLL_ON_COLO2 =
  "HORIZONTAL_SCROLL_ON_COLO2";
export const FEATURE_FLAG_QUANTUM_METRIC = "2025-quantum-metric";
export const FEATURE_FLAG_LOCALIZATION_ON_COLO2 =
  "SERVICES_FRENCH_LOCALIZATION_ENABLED";
export const DEPOSIT_TAKING_FOR_SERVICES_ENABLED =
  "DEPOSIT_TAKING_FOR_SERVICES_ENABLED";

export const DEFAULT_ID = "default";

// Routes
export const ROUTE_HOME = "/";
export const ROUTE_RETAIL = "";
export const ROUTE_SERVICES = "/services";
export const ROUTE_ALL = "/all";
export const ROUTE_SERVICES_ALL = `${ROUTE_SERVICES}/all`;
export const ROUTE_MENU = "/menu";
export const ROUTE_MENU_ALL = `${ROUTE_MENU}/all`;
export const ROUTE_SHOP = "/shop";
export const ROUTE_CATEGORIES = "/categories";
export const ROUTE_CATEGORIES_ALL = `${ROUTE_CATEGORIES}/all`;
export const ROUTE_CONFIRMATION = "/confirmation";
export const ROUTE_NOT_FOUND = "/not-found";
export const ROUTE_GUEST_CHECKOUT = "/guest-checkout";
export const ROUTE_CHECKOUT = "/checkout";
export const ROUTE_CUSTOMER_PROFILE = "/customer-profile";
export const ROUTE_MY_ORDERS = "/my-orders";
export const ROUTE_MY_APPOINTMENTS = "/my-appointments";
export const ROUTE_VERIFY_EMAIL = "/verify-email";
export const ROUTE_UNCATEGORISED = "Uncategorized";
export const ROUTE_GIFTCARD = "/giftcard";

export const UNCATEGORISED_CATEGORY_ID = "uncategorised";
export const UNCATEGORISED_CACHE_KEY = "uncategorized";

export const RETAIL_ITEMS_FETCH_LIMIT = "999";

export const GOOGLEMAP_URL = "https://maps.googleapis.com/maps/api/js";
export const PRIVACY_POLICY_URL = "https://www.clover.com/privacy-policy";

// Time constants for calculations
export const TIME_CONSTANTS = {
  MINUTES_PER_HOUR: 60,
  MINUTES_PER_DAY: 1440,
  HOURS_PER_DAY: 24,
  SECONDS_PER_MINUTE: 60,
  MILLISECONDS_PER_SECOND: 1000,
  MILLISECONDS_PER_MINUTE: 60 * 1000, // 60000
} as const;

export const DELIVERY_TIP_SUGGESTIONS = [
  {
    id: "FB00MRRQF32PG",
    name: null,
    percentage: 15,
  },
  {
    id: "08F1QBKDN84ZJ",
    name: null,
    percentage: 18,
  },
  {
    id: "M0GQ9889NJ5Q4",
    name: null,
    percentage: 20,
  },
  {
    id: "TK05FMS88WAX0",
    name: null,
    percentage: 25,
  },
];

// API routes
export const API_ROUTE_APPOINTMENTS = "/api/appointments";

export const EMAIL_TYPO_MAP: Record<string, string> = {
  con: "com",
  vom: "com",
  clm: "com",
  comp: "com",
  col: "com",
  fom: "com",
  cim: "com",
  xom: "com",
  gom: "com",
  ckm: "com",
  come: "com",
  cok: "com",
  cpm: "com",
  comm: "com",
  conm: "com",
  vo: "com",
  ney: "net",
  ner: "net",
  nsu: "net",
  ed: "edu",
  eud: "edu",
  du: "edu",
  ogr: "org",
  or: "org",
  og: "org",
  urg: "org",
  rog: "org",
  couk: "co.uk",
  "co.um": "co.uk",
  "co.u": "co.uk",
  "cp.uk": "co.uk",
};

export const MERCHANT_TYPES = {
  HYBRID: "HYBRID",
  SERVICE: "SERVICE",
  RESTAURANT: "RESTAURANT",
  ESSENTIAL: "ESSENTIAL",
  SERVICE_RETAIL_ONLY: "SERVICE_RETAIL_ONLY",
  RETAIL: "RETAIL",
} as const;

// Product Types
export const PRODUCT_TYPE_SERVICE = "SERVICE";
export const PRODUCT_TYPE_REGULAR = "REGULAR";

// Path Segments
export const PATH_SERVICES = "services";
export const PATH_SHOP = "shop";
export const PATH_MENU = "menu";
export const PATH_CATEGORIES = "categories";

// Template Names
export const TEMPLATE_IMAGE_FOCUSED = "image focused";
export const TEMPLATE_DESCRIPTION_FOCUSED = "description focused";
